export default (n) => {
  return (n / 1).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
}
